import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Logo from './Logo';
import styles from './Navbar.module.css';

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const { user, logout, isLoggedIn } = useAuth();
  const navigate = useNavigate();
  const handleLogout = () => { logout(); navigate('/'); };

  return (
    <nav className={styles.nav}>
      <Link to="/" className={styles.logo}>
        <Logo size={38} />
        <div className={styles.logoText}>
          <span className={styles.logoName}>Nieruchomy</span>
          <span className={styles.logoSub}>.pl · portal ogłoszeń</span>
        </div>
      </Link>
      <ul className={`${styles.links} ${menuOpen ? styles.open : ''}`}>
        <li><Link to="/ogloszenia?type=sprzedaz">Sprzedaż</Link></li>
        <li><Link to="/ogloszenia?type=wynajem">Wynajem</Link></li>
        <li><Link to="/ogloszenia?type=nowe">Nowe inwestycje</Link></li>
        {isLoggedIn ? (
          <>
            {user?.role === 'admin' && (
              <li><Link to="/admin" className={styles.adminLink}>⚙ Admin</Link></li>
            )}
            <li><Link to="/moje-ogloszenia" className={styles.myLink}>Moje ogłoszenia</Link></li>
            <li><Link to="/dodaj" className={styles.cta}>+ Dodaj ogłoszenie</Link></li>
            <li><button className={styles.logoutBtn} onClick={handleLogout}>Wyloguj ({user?.name?.split(' ')[0]})</button></li>
          </>
        ) : (
          <>
            <li><Link to="/logowanie" className={styles.loginBtn}>Logowanie</Link></li>
            <li><Link to="/rejestracja" className={styles.cta}>Zarejestruj się</Link></li>
          </>
        )}
      </ul>
      <button className={styles.burger} onClick={() => setMenuOpen(o => !o)}>
        <span /><span /><span />
      </button>
    </nav>
  );
}
